import React, { useMemo } from "react";
import dynamic from "next/dynamic";

import { axiosApiInstance } from "../pages/api/axios";
import Drawer from "./Drawer";
import { useMoneyHashQuery } from "../hooks/useMoneyHashQuery";
import { FormSkeleton } from "./skeletons";

const DynamicForm = dynamic(() => import("./DynamicForm"));

export default function EditPopOverForm(props) {
  const { title, open, setOpen, Trigger } = props;

  return (
    <React.Fragment>
      {Trigger && <Trigger onClick={() => setOpen(true)} />}

      <Drawer isOpen={open} onClose={() => setOpen(false)} title={title}>
        <FormContent {...props} />
      </Drawer>
    </React.Fragment>
  );
}

const FormContent = ({ url, onSuccess, setOpen }) => {
  const { data, isLoading } = useMoneyHashQuery({
    queryKey: ["form-fields", { url }],
    queryFn: ({ signal }) =>
      axiosApiInstance
        .get(url, { signal })
        .then((res) => ({ data: res.data.data.form_fields })),
    enabled: !!url,
  });

  const formFields = useMemo(() => {
    return data?.filter(({ read_only }) => !read_only);
  }, [data]);

  if (isLoading) return <FormSkeleton />;

  return (
    formFields && (
      <DynamicForm
        fields={formFields}
        submitURL={url}
        onSuccess={(name) => {
          setOpen(false);
          onSuccess(name);
        }}
        onCancel={() => setOpen(false)}
        editForm
      />
    )
  );
};
